export const BODY_PARTS = [
  { value: "hip", label: "hip" },
  { value: "knee", label: "knee" },
  { value: "lower back", label: "lower Back" },
  { value: "shoulder", label: "shoulder" },
  { value: "hand", label: "hand" },
  { value: "neck", label: "neck" },
  { value: "elbow", label: "elbow" },
  { value: "foot", label: "foot" },
  { value: "wrist", label: "wrist" },
  { value: "ankle", label: "ankle" },
  { value: "fall prevention", label: "fall prevention" },
  { value: "osteoporosis", label: "osteoporosis" },
];

export const TIMEZONES = [
  { value: "pacific_time", label: "Pacific Time" },
  { value: "mountain_time", label: "Mountain Time" },
  { value: "central_time", label: "Central Time" },
  { value: "eastern_time", label: "Eastern Time" },
];
